import { connect } from 'react-redux';
import type { ConnectedProps } from 'react-redux';

import { getIsMobile } from 'src/store/view/selectors';
import {
  isSecondStepDone,
  getOrderIsCreated,
} from '../../../../store/selectors/order';

import { ServicesRoute } from './Services';

const mapStateToProps = (state) => ({
  redirectToHome: !isSecondStepDone(state),
  isCreated: getOrderIsCreated(state),
  isMobile: getIsMobile(state),
});

const connector = connect(mapStateToProps);
export type PropsFromRedux = ConnectedProps<typeof connector>;

export default connector(ServicesRoute);
